var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._b({staticClass:"common-link",style:(_vm._sx),attrs:{"href":_vm.disabled ? undefined : _vm.href,"target":_vm.target,"rel":_vm.rel},on:{"click":_vm.handleClick}},'a',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }